<p>side-navigation-submenu-redaction works!</p>
